import React, { useState, useEffect} from 'react';
import '../view-archer-styles.css';

//material UI
import { Alert, Card, CardContent, Chip, Checkbox, Divider, Grid, Link, Stack, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from '@mui/material/';
import { green, red} from '@mui/material/colors';
import { CreditCard, MeetingRoomOutlined, AttachFile} from '@mui/icons-material/';

//components import
import AlertInfoDialog from '../../../components/elements/AlertInfoDialog';
import AlertInfo from '../../../dataObjects/AlertInfo';
import ExcessContributionGroup from '../dataObjects/ExcessContributionGroup';
import FlaggedItem from '../dataObjects/FlaggedItem';
import ArcherResponse from '../dataObjects/ArcherResponse';
import PotentialRefundExpenditureResponse from '../dataObjects/PotentialRefundExpenditureResponse';
import UploadedFileViewer from './UploadedFileViewer';
import FilerGatewayUploadResponsesDialog from './FilerGatewayUploadResponsesDialog';

interface RefundTrackerProps {
    cpfId: number;
}

enum RefundRelatedResponseType {
    GatewayRefundCheckUpload = 6,
    ArcherRefundCheckUpload = 16,
    AuditResponsePdf = 17,
    LinkedEfiledReport = 13,
    PrfRefundExpenditure = 26
}

const FilerRefundTracker = (props: RefundTrackerProps) => {

    useEffect(() => {
        getRefundTrackerPayload();
    }, []);


    const getRefundTrackerPayload = async () => {
        await fetch(`/archer3/GetRefundTrackerPayload?cpfId=${props.cpfId}`)
            .then(result => result.json())
            .then(result => {
                if (result.isError) {
                    let info = {
                        type: 'error',
                        title: 'Error: GetRefundTrackerPayload',
                        errorMessage: result.errorMessage,
                        secondaryErrorMessage: result.secondaryErrorMessage
                    };
                    setAlertInfo(info);
                    setAlertInfoDialog(true);
                }
                else {
                    let excessContributionGroups = result.result.excessContributionGroups;
                    setExcessContributionGroups(excessContributionGroups);

                    let unlinkedExcess: ExcessContributionGroup[] = [];
                    let pendingExcess: ExcessContributionGroup[] = [];
                    let linkedExcess: ExcessContributionGroup[] = [];
                    
                    excessContributionGroups.forEach((group: ExcessContributionGroup) => {
                        if (group.linkedUploadedRefundCheckResponses.length === 0 && group.linkedBankExpenditureResponses.length === 0) {
                            unlinkedExcess.push(group);
                        }

                        if (group.linkedUploadedRefundCheckResponses.length > 0 && group.linkedBankExpenditureResponses.length === 0) {
                            pendingExcess.push(group);
                        }

                        if (group.linkedBankExpenditureResponses.length > 0) {
                            linkedExcess.push(group);
                        }
                    })
                    setUnlinkedExcessContributionGroups(unlinkedExcess);
                    setPendingExcessContributions(pendingExcess);
                    setLinkedExcessContributions(linkedExcess);

                    setUnlinkedBankExpenditures(result.result.unlinkedExcessRefundExpenditures);
                    setUnlinkedResponses(result.result.unlinkedRefundCheckUploads);
                }
            })
    }

    /*Excess Contribution Groups*/
    const [excessContributionGroups, setExcessContributionGroups] = useState<ExcessContributionGroup[]>();
    const [unlinkedExcessContributionGroups, setUnlinkedExcessContributionGroups] = useState<ExcessContributionGroup[]>();
    const [pendingExcessContributionGroups, setPendingExcessContributions] = useState<ExcessContributionGroup[]>();
    const [linkedExcessContributionGroups, setLinkedExcessContributions] = useState<ExcessContributionGroup[]>();

    /*Refund & Responses*/
    const [unLinkedBankExpenditures, setUnlinkedBankExpenditures] = useState<PotentialRefundExpenditureResponse[]>();
    const [unLinkedResponses, setUnlinkedResponses] = useState<ArcherResponse[]>();

   
    /*Identify the selected issue and group*/
    const [selectedGroupIndex, setSelectedGroupIndex] = useState(-1);
    const [selectedGroupUi, setSelectedGroupUi] = useState("");
    const [selectedIssueId, setSelectedIssueId] = useState(0);

    /* add,remove responses */
    const [selectedResponseIds, setSelectedResponseIds] = useState<number[]>([]);

    function handleResponseCheckbox(event: any, responseId: number) {
        if (event.target.checked) {
            addResponseToList(responseId);
        }
        else {
            removeResponseFromList(responseId);
        }
    }

    const addResponseToList = (responseId: number) => {
        if (responseId > 0) {
            setSelectedResponseIds([...selectedResponseIds, responseId]);
        }
    }

    const removeResponseFromList = (responseId: number) => {
        if (responseId > 0) {
            setSelectedResponseIds(selectedResponseIds.filter(id => id !== responseId));
        }
    }

    const isResponseSelected = (responseId: number) => {
        return selectedResponseIds.includes(responseId);
    }

    /*dismiss response*/
    const dismissRefundCheckResponse = (response: ArcherResponse) => {
        let url = `/Archer3/DismissSuggestedResponse?currentResponseId=${response.id}`
        fetch(url)
            .then(result => result.json())
            .then(result => {
                if (result.isError) {
                    let info = {
                        type: 'error',
                        title: 'Error: DismissSuggestedResponse',
                        errorMessage: result.errorMessage,
                        secondaryErrorMessage: result.secondaryErrorMessage
                    };
                    setAlertInfo(info);
                    setAlertInfoDialog(true);
                }
                else {
                    getRefundTrackerPayload();
                }
            })
    }
    const dismissSuggestedResponse = (response: PotentialRefundExpenditureResponse) => {
        let url = `/Archer3/DismissSuggestedResponse?currentResponseId=${response.id}`
        fetch(url)
            .then(result => result.json())
            .then(result => {
                if (result.isError) {
                    let info = {
                        type: 'error',
                        title: 'Error: DismissSuggestedResponse',
                        errorMessage: result.errorMessage,
                        secondaryErrorMessage: result.secondaryErrorMessage
                    };
                    setAlertInfo(info);
                    setAlertInfoDialog(true);
                }
                else {
                    getRefundTrackerPayload();
                }
            })
    }

    /*duplicate response*/

    const duplicateRefundCheckResponse = (response: ArcherResponse) => {
        let url = `/Archer3/DuplicateResponse?responseId=${response.id}`
        fetch(url)
            .then(result => result.json())
            .then(result => {
                if (result.isError) {
                    let info = {
                        type: 'error',
                        title: 'Error: DuplicateResponse',
                        errorMessage: result.errorMessage,
                        secondaryErrorMessage: result.secondaryErrorMessage
                    };
                    setAlertInfo(info);
                    setAlertInfoDialog(true);
                }
                else {
                    getRefundTrackerPayload();
                }
            })
    }
    const duplicateSuggestedResponse = (response: PotentialRefundExpenditureResponse) => {
        let url = `/Archer3/DuplicateResponse?responseId=${response.id}`
        fetch(url)
            .then(result => result.json())
            .then(result => {
                if (result.isError) {
                    let info = {
                        type: 'error',
                        title: 'Error: DuplicateResponse',
                        errorMessage: result.errorMessage,
                        secondaryErrorMessage: result.secondaryErrorMessage
                    };
                    setAlertInfo(info);
                    setAlertInfoDialog(true);
                }
                else {
                    getRefundTrackerPayload();
                }
            })
    }

    /*link Excess Group to responses*/
    const setSelectedGroup = (excessGroup: ExcessContributionGroup) => {
        //setSelectedGroupIndex(index);
        setSelectedGroupUi(excessGroup.groupUi);
        setSelectedIssueId(excessGroup.issueId);
    }

    const linkExcessGroupToResponse = () => {

        if (selectedResponseIds.length === 0 || selectedIssueId === 0) {
            let info = {
                type: 'error',
                title: `Error: No response(s) selected`,
                errorMessage: 'Please select both excess contribution group and responses to link',
                secondaryErrorMessage: ''
            };
            setAlertInfo(info);
            setAlertInfoDialog(true);
        }
        else {
            var params = [
                `issueId=${selectedIssueId}`,
                `groupUi=${selectedGroupUi}`,
                `responseIds=${selectedResponseIds.toString()}`
            ].join('&');

            let url = `/Archer3/LinkExcessGroupToResponse?${params}`
            fetch(url)
                .then(result => result.json())
                .then(result => {
                    if (result.isError) {
                        let info = {
                            type: 'error',
                            title: 'Error: LinkExcessGroupToResponse',
                            errorMessage: result.errorMessage,
                            secondaryErrorMessage: result.secondaryErrorMessage
                        };
                        setAlertInfo(info);
                        setAlertInfoDialog(true);
                    }
                    else {
                        getRefundTrackerPayload();
                        setSelectedGroupIndex(-1);
                        setSelectedGroupUi("");
                        setSelectedIssueId(0);
                        setSelectedResponseIds([]);
                    }
                })
        }     
    }

    /*Unlink responses*/
    const unlinkExcessGroup = (excessGroup: ExcessContributionGroup) => {
        var params = [
            `issueId=${excessGroup.issueId}`,
            `groupUi=${excessGroup.groupUi}`
        ].join('&');

        let url = `/Archer3/UnlinkExcessGroupResponse?${params}`
        fetch(url)
            .then(result => result.json())
            .then(result => {
                if (result.isError) {
                    let info = {
                        type: 'error',
                        title: 'Error: UnlinkExcessGroupResponse',
                        errorMessage: result.errorMessage,
                        secondaryErrorMessage: result.secondaryErrorMessage
                    };
                    setAlertInfo(info);
                    setAlertInfoDialog(true);
                }
                else {
                    getRefundTrackerPayload();
                    setSelectedGroupIndex(-1);
                    setSelectedGroupUi("");
                    setSelectedIssueId(0);
                    setSelectedResponseIds([]);
                }
            })
    }

    /* FILE VIEWER */
    const [isFileViewerDialogOpen, setFileViewerDialogOpen] = useState(false);
    const [fileUrl, setFileUrl] = useState('');
    const [currentResponseId, setCurrentResponseId] = useState(0);

    const openFileViewerDialog = (response: any) => {
        setFileUrl('/Archer3/uploads?fileName=' + response.uploadedFileName);
        setFileViewerDialogOpen(true);
        setCurrentResponseId(response.id);
    };

    const closeFileViewerDialog = () => {
        setFileViewerDialogOpen(false);
    };

    /*SELECT OR UPLOAD RESPONSE*/
    const [isUploadResponsesDialogOpen, setUploadResponsesDialogOpen] = useState(false);

    const openUploadResponsesDialog = () => {
        setUploadResponsesDialogOpen(true);
    };

    const closeUploadResponsesDialog = () => {
        setUploadResponsesDialogOpen(false);
        getRefundTrackerPayload();
    }

    /*Error Handling*/
    const [isAlertInfoDialogOpen, setAlertInfoDialog] = useState(false);
    const [alertInfo, setAlertInfo] = useState<AlertInfo>();
    const closeAlertInfoDialog = () => {
        setAlertInfoDialog(false);
    }

    return (
        <div className="filer-refund-tracker-manager">
            <Grid container sx={{marginBottom: 1.5}} ></Grid>
            {
                excessContributionGroups &&
                excessContributionGroups.length > 0 &&
                <>
                    <Grid container>
                        <Grid item xs={4.5}>
                            <Typography variant="subtitle2"><strong>Excess Contributions</strong></Typography>
                        </Grid>
                        <Grid item xs={2}>
                            <Stack direction="row" spacing={2}>
                                <Chip label='Link' variant="outlined" color="success" onClick={linkExcessGroupToResponse} />
                            </Stack>
                        </Grid>
                        <Grid item xs={5.5}>
                            <Typography variant="subtitle2"><strong>Refund & Responses</strong></Typography>
                        </Grid>
                    </Grid>
                    { /*Unlinked Excess Contributions*/}
                    <Grid container className="unlinked-excess-contributions">
                        <Grid item xs={4.5}>
                            {
                                unlinkedExcessContributionGroups &&
                                unlinkedExcessContributionGroups.length > 0 &&
                                unlinkedExcessContributionGroups.map((group, index) =>
                                    <Card variant="outlined" className="excess-contributions-card is-clickable" key={index} onClick={() => setSelectedGroup(group)} >
                                        <CardContent className={`card-content ${group.groupUi === selectedGroupUi ? "selected-group" : ""}`} >
                                            <Grid container className="excess-section">
                                                <TableContainer sx={{ maxHeight: 400 }}>
                                                    <Table stickyHeader sx={{ minWidth: 400 }} size="small" aria-label="Flagged Items Table">
                                                        <TableBody>
                                                            {
                                                                group.items &&
                                                                group.items.length > 0 &&
                                                                group.items.map((item: FlaggedItem, index: number) => (
                                                                    <TableRow
                                                                        key={item.flaggedItemId}
                                                                    >
                                                                        <TableCell><Link href={`https://www.ocpf.us/Reports/DisplayReport?menuHidden=true&id=${item.reportId}`} target="_blank" underline="none">{item.date}</Link></TableCell>
                                                                        <TableCell>{item.fullName}</TableCell>
                                                                        <TableCell align="right">{item.amount}</TableCell>
                                                                    </TableRow>
                                                                ))
                                                            }
                                                            {
                                                                <TableRow key={group.groupUi} >
                                                                    <TableCell><strong>{group.groupUi}</strong></TableCell>
                                                                    <TableCell><Typography sx={{ color: red[500] }}><i>Amount to refund</i></Typography></TableCell>
                                                                    <TableCell><Typography sx={{ color: red[500] }}>{group.amountToRefund}</Typography></TableCell>
                                                                </TableRow>
                                                            }
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </Grid>
                                        </CardContent>
                                    </Card>
                                )
                            }
                        </Grid>
                        <Grid item xs={0.5} sx={{ backgroundColor: green[200], marginTop: 1 }}></Grid>
                        <Grid item xs={7}>
                            <Card variant="outlined" className="excess-contributions-card is-clickable">
                                <CardContent className="card-content">
                                    <Grid container className="responses-section">
                                        <TableContainer>
                                            <Table stickyHeader sx={{ minWidth: 450 }} size="small" aria-label="Flagged Items Table">
                                                <TableBody>
                                                    {
                                                        unLinkedResponses &&
                                                        unLinkedResponses.length > 0 &&
                                                        unLinkedResponses.map((response: ArcherResponse) => (
                                                            <TableRow
                                                                key={response.id}
                                                                className={`${isResponseSelected(response.id) ? "selected-item" : ""}`}
                                                            >
                                                                <TableCell><Checkbox onChange={(event) => handleResponseCheckbox(event, response.id)} /></TableCell>
                                                                <TableCell><Link href={`https://www.ocpf.us/Reports/DisplayReport?menuHidden=true&id=${response.reportId}`} target="_blank" underline="none">{response.responseDate}</Link></TableCell>
                                                                <TableCell><b>{response.groupUi}</b></TableCell>
                                                                <TableCell>
                                                                    {
                                                                        response.responseType == RefundRelatedResponseType.GatewayRefundCheckUpload &&
                                                                        <Stack direction="row" spacing={1}>
                                                                            <MeetingRoomOutlined fontSize="small" />
                                                                            <Typography variant="body2"> Gateway Uploads</Typography>
                                                                        </Stack>
                                                                    }
                                                                    {
                                                                        response.responseType == RefundRelatedResponseType.ArcherRefundCheckUpload &&
                                                                        <Stack direction="row" spacing={1}>
                                                                            <AttachFile fontSize="small" />
                                                                            <Typography variant="body2"> Archer Uploads</Typography>
                                                                        </Stack>
                                                                    }
                                                                    {
                                                                        response.responseType == RefundRelatedResponseType.AuditResponsePdf &&
                                                                        <Stack direction="row" spacing={1}>
                                                                            <AttachFile fontSize="small" />
                                                                            <Typography variant="body2">Audit Response</Typography>
                                                                        </Stack>
                                                                    }
                                                                </TableCell>
                                                                <TableCell>
                                                                    {
                                                                        (response.responseType == RefundRelatedResponseType.ArcherRefundCheckUpload || response.responseType == RefundRelatedResponseType.GatewayRefundCheckUpload) &&
                                                                        <Chip label='View Refund' variant="outlined" color="primary" size="small" onClick={() => openFileViewerDialog(response)} />
                                                                    }
                                                                    {
                                                                        response.responseType === RefundRelatedResponseType.AuditResponsePdf &&
                                                                        <Link sx={{ width: 150, paddingTop: 2 }} href={response.pdfFileUrl} target="_blank" underline="none">
                                                                            {response.responseDescription}
                                                                        </Link>
                                                                    }
                                                                </TableCell>
                                                                <TableCell align="right">
                                                                    <Stack direction="row" spacing={1}>
                                                                        <Chip label='Dismiss' size="small" variant="outlined" color="warning" onClick={() => dismissRefundCheckResponse(response)} />
                                                                        <Chip label='Duplicate' size="small" variant="outlined" color="warning" onClick={() => duplicateRefundCheckResponse(response)} />
                                                                    </Stack>
                                                                </TableCell>
                                                            </TableRow>
                                                        ))
                                                    }
                                                    {
                                                        unLinkedBankExpenditures &&
                                                        unLinkedBankExpenditures.length > 0 &&
                                                        unLinkedBankExpenditures.map((item: PotentialRefundExpenditureResponse, index: number) => (
                                                            <TableRow
                                                                key={item.id}
                                                                className={`${isResponseSelected(item.id) ? "selected-item" : ""}`}
                                                            >
                                                                <TableCell><Checkbox onChange={(event) => handleResponseCheckbox(event, item.id)} /></TableCell>
                                                                <TableCell><Link href={`https://www.ocpf.us/Reports/DisplayReport?menuHidden=true&id=${item.reportId}`} target="_blank" underline="none">{item.date}</Link></TableCell>
                                                                <TableCell><b>{item.name}</b></TableCell>
                                                                <TableCell>
                                                                    <Stack direction="row" spacing={1} >
                                                                        <CreditCard fontSize="small" />
                                                                        <Typography variant="body2"> Bank Report</Typography>
                                                                    </Stack>
                                                                </TableCell>
                                                                <TableCell>{item.description} <b>{item.amount}</b></TableCell>
                                                                <TableCell align="right">
                                                                    <Stack direction="row" spacing={1}>
                                                                        <Chip label='Dismiss' size="small" variant="outlined" color="warning" onClick={() => dismissSuggestedResponse(item)} />
                                                                        <Chip label='Duplicate' size="small" variant="outlined" color="warning" onClick={() => duplicateSuggestedResponse(item)} />
                                                                    </Stack>
                                                                </TableCell>
                                                            </TableRow>
                                                        ))
                                                    }
                                                   
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>

                    { /*Pending Excess Contributions*/}
                    <Divider sx={{ margin: 5 }}><Chip label="Pending: wait checks to be cleared" size="small" color="warning" variant="outlined" /></Divider>
                    <Grid container className="pending-excess-contributions">
                        <Grid item xs={12}>
                            {
                                pendingExcessContributionGroups &&
                                pendingExcessContributionGroups.length > 0 &&
                                pendingExcessContributionGroups.map((group, index) =>
                                    <Card variant="outlined" key={index} sx={{ marginTop: 1 }} className="excess-contributions-card is-clickable">
                                        <CardContent>
                                            <Grid container>
                                                <Grid item xs={4.5} onClick={() => setSelectedGroup(group)}>
                                                    <TableContainer sx={{ maxHeight: 400 }} >
                                                        <Table stickyHeader sx={{ minWidth: 400 }} size="small" aria-label="Flagged Items Table">
                                                            <TableBody className={`card-content ${group.groupUi === selectedGroupUi ? "selected-group" : ""}`}>
                                                                {
                                                                    group.items &&
                                                                    group.items.length > 0 &&
                                                                    group.items.map((item: any, index: number) => (
                                                                        <TableRow
                                                                            key={item.flaggedItemId}
                                                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                                        >
                                                                            <TableCell><Link href={`https://www.ocpf.us/Reports/DisplayReport?menuHidden=true&id=${item.reportId}`} target="_blank" underline="none">{item.date}</Link></TableCell>
                                                                            <TableCell>{item.fullName}</TableCell>
                                                                            <TableCell align="right">{item.amount}</TableCell>
                                                                        </TableRow>
                                                                    ))
                                                                }
                                                                {
                                                                    <TableRow key={group.groupUi} >
                                                                        <TableCell><strong>{group.groupUi}</strong></TableCell>
                                                                        <TableCell><Typography sx={{ color: red[500] }}><i>Amount to refund</i></Typography></TableCell>
                                                                        <TableCell><Typography sx={{ color: red[500] }}>{group.amountToRefund}</Typography></TableCell>
                                                                    </TableRow>
                                                                }
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </Grid>
                                                <Grid item xs={1}><Chip label='Pending' onDelete={()=>unlinkExcessGroup(group)} color="warning" size="small" /></Grid>
                                                <Grid item xs={6.5}>
                                                    <TableContainer>
                                                        <Table stickyHeader sx={{ minWidth: 450 }} size="small" aria-label="Flagged Items Table">
                                                            <TableBody>
                                                                {
                                                                    group.linkedUploadedRefundCheckResponses.length > 0 &&
                                                                    group.linkedUploadedRefundCheckResponses.map((response: ArcherResponse) => (
                                                                        <TableRow
                                                                            key={response.id}
                                                                        >
                                                                            <TableCell><Link href={`https://www.ocpf.us/Reports/DisplayReport?menuHidden=true&id=${response.reportId}`} target="_blank" underline="none">{response.responseDate}</Link></TableCell>
                                                                            <TableCell><b>{response.groupUi}</b></TableCell>
                                                                            <TableCell>
                                                                                {
                                                                                    response.responseType == RefundRelatedResponseType.GatewayRefundCheckUpload &&
                                                                                    <Typography variant="body2">Gateway Uploads</Typography>
                                                                                }
                                                                                {
                                                                                    response.responseType == RefundRelatedResponseType.ArcherRefundCheckUpload &&
                                                                                    <Typography variant="body2">Archer Uploads</Typography>
                                                                                }
                                                                                {
                                                                                    response.responseType == RefundRelatedResponseType.AuditResponsePdf &&
                                                                                    <Typography variant="body2">Audit Response</Typography>
                                                                                }
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                {
                                                                                    (response.responseType == RefundRelatedResponseType.ArcherRefundCheckUpload || response.responseType == RefundRelatedResponseType.GatewayRefundCheckUpload) &&
                                                                                    <Chip label='View Refund' variant="outlined" color="primary" size="small" onClick={() => openFileViewerDialog(response)} />
                                                                                }
                                                                                {
                                                                                    response.responseType === RefundRelatedResponseType.AuditResponsePdf &&
                                                                                    <Link sx={{ width: 150, paddingTop: 2 }} href={response.pdfFileUrl} target="_blank" underline="none">
                                                                                        {response.responseDescription}
                                                                                    </Link>
                                                                                }
                                                                            </TableCell>
                                                                            <TableCell align="right"></TableCell>
                                                                        </TableRow>
                                                                    ))
                                                                }
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                    </Card>
                                )
                            }
                        </Grid>
                    </Grid>
                    { /*Linked Excess Contributions*/}
                    <Divider sx={{ margin: 5 }}><Chip label="Resolved" size="small" color="success" variant="outlined" /></Divider>
                    <Grid container className="linked-excess-contributions">
                        <Grid item xs={12}>
                            {
                                linkedExcessContributionGroups &&
                                linkedExcessContributionGroups.length > 0 &&
                                linkedExcessContributionGroups.map((group, index) =>
                                    <Card variant="outlined" key={index} sx={{ marginTop: 1 }}>
                                        <CardContent>
                                            <Grid container>
                                                <Grid item xs={4.5}>
                                                    <TableContainer sx={{ maxHeight: 400 }}>
                                                        <Table stickyHeader sx={{ minWidth: 400 }} size="small" aria-label="Flagged Items Table">
                                                            <TableBody>
                                                                {
                                                                    group.items &&
                                                                    group.items.length > 0 &&
                                                                    group.items.map((item: any, index: number) => (
                                                                        <TableRow
                                                                            key={item.flaggedItemId}
                                                                        >
                                                                            <TableCell><Link href={`https://www.ocpf.us/Reports/DisplayReport?menuHidden=true&id=${item.reportId}`} target="_blank" underline="none">{item.date}</Link></TableCell>
                                                                            <TableCell>{item.fullName}</TableCell>
                                                                            <TableCell align="right">{item.amount}</TableCell>
                                                                        </TableRow>
                                                                    ))
                                                                }
                                                                {
                                                                    <TableRow key={group.groupUi} >
                                                                        <TableCell><strong>{group.groupUi}</strong></TableCell>
                                                                        <TableCell><Typography sx={{ color: red[500] }}><i>Amount to refund</i></Typography></TableCell>
                                                                        <TableCell><Typography sx={{ color: red[500] }}>{group.amountToRefund}</Typography></TableCell>
                                                                    </TableRow>
                                                                }
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </Grid>
                                                <Grid item xs={1}><Chip label='Linked' onDelete={() => unlinkExcessGroup(group)} color="success" size="small" /></Grid>
                                                <Grid item xs={6.5}>
                                                    <TableContainer>
                                                        <Table stickyHeader sx={{ minWidth: 450 }} size="small" aria-label="Flagged Items Table">
                                                            <TableBody>
                                                                {
                                                                    group.linkedUploadedRefundCheckResponses.length > 0 &&
                                                                    group.linkedUploadedRefundCheckResponses.map((response: any, index: number) => (
                                                                        <TableRow
                                                                            key={response.id}
                                                                        >
                                                                            <TableCell><Link href={`https://www.ocpf.us/Reports/DisplayReport?menuHidden=true&id=${response.reportId}`} target="_blank" underline="none">{response.responseDate}</Link></TableCell>
                                                                            <TableCell><b>{response.groupUi}</b></TableCell>
                                                                            <TableCell>
                                                                                {
                                                                                    response.responseType == RefundRelatedResponseType.GatewayRefundCheckUpload &&
                                                                                    <Typography variant="body2">Gateway Uploads</Typography>
                                                                                }
                                                                                {
                                                                                    response.responseType == RefundRelatedResponseType.ArcherRefundCheckUpload &&
                                                                                    <Typography variant="body2">Archer Uploads</Typography>
                                                                                }
                                                                                {
                                                                                    response.responseType == RefundRelatedResponseType.AuditResponsePdf &&
                                                                                    <Typography variant="body2">Audit Response</Typography>
                                                                                }
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                {
                                                                                    (response.responseType == RefundRelatedResponseType.ArcherRefundCheckUpload || response.responseType == RefundRelatedResponseType.GatewayRefundCheckUpload) &&
                                                                                    <Chip label='View Refund' variant="outlined" color="primary" size="small" onClick={() => openFileViewerDialog(response)} />
                                                                                }
                                                                                {
                                                                                    response.responseType === RefundRelatedResponseType.AuditResponsePdf &&
                                                                                    <Link sx={{ width: 150, paddingTop: 2 }} href={response.pdfFileUrl} target="_blank" underline="none">
                                                                                        {response.responseDescription}
                                                                                    </Link>
                                                                                }
                                                                            </TableCell>
                                                                            <TableCell align="right"></TableCell>
                                                                        </TableRow>
                                                                    ))
                                                                }
                                                                {
                                                                    group.linkedBankExpenditureResponses.length > 0 &&
                                                                    group.linkedBankExpenditureResponses.map((expenditure: PotentialRefundExpenditureResponse, index: number) => (
                                                                        <TableRow
                                                                            key={expenditure.id}
                                                                        >
                                                                            <TableCell><Link href={`https://www.ocpf.us/Reports/DisplayReport?menuHidden=true&id=${expenditure.reportId}`} target="_blank" underline="none">{expenditure.date}</Link></TableCell>
                                                                            <TableCell><b>{expenditure.name}</b></TableCell>
                                                                            <TableCell>{'Bank Report'}</TableCell>
                                                                            <TableCell>{expenditure.description}</TableCell>
                                                                            <TableCell align="right">{expenditure.amount}</TableCell>
                                                                        </TableRow>
                                                                    ))
                                                                }
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                    </Card>
                                )
                            }
                        </Grid>
                    </Grid>
                </>
            }
            {
                excessContributionGroups &&
                excessContributionGroups.length === 0 &&
                <Alert severity="success" sx={{marginBottom:2}}>There are no excess contributions!</Alert>
            }
            {/*Upload response dialog*/}
            <FilerGatewayUploadResponsesDialog cpfId={props.cpfId} isUploadResponsesDialogOpen={isUploadResponsesDialogOpen} closeUploadResponsesDialog={closeUploadResponsesDialog}></FilerGatewayUploadResponsesDialog>
            {/* View uploaded file */}
            <UploadedFileViewer fileUrl={fileUrl} responseId={currentResponseId} isFileViewerDialogOpen={isFileViewerDialogOpen} closeFileViewerDialog={closeFileViewerDialog}></UploadedFileViewer>
            {
                alertInfo &&
                <AlertInfoDialog isAlertInfoDialogOpen={isAlertInfoDialogOpen} alertInfo={alertInfo} closeAlertInfoDialog={closeAlertInfoDialog}></AlertInfoDialog>
            }
        </div>
        )
    
}

export default FilerRefundTracker;